module.exports = __webpack_public_path__ + "img/People.810b8f3f.png";